import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsTabNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data : {
        id: props.jobId,
      },
      customerAllJobsPage:props.customerAllJobsPage || false,
      approvePickupAppraisal:props.approvePickupAppraisal || false,
      approveDropoffAppraisal:props.approveDropoffAppraisal || false,
      isQuickLookupJob:props.isQuickLookupJob || false
    };
  } 

  componentWillReceiveProps(nextProps) {
    this.setState({ 
      data: { 
        id: nextProps.jobId
      },
      customerAllJobsPage:nextProps.customerAllJobsPage
    });
  }
  render() {
    return (
      <ul className="nav nav-tabs no-select">
        {(!this.state.isQuickLookupJob) ? 
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-main-details"}
            className="active"
          >
            <i className="fa fa-info-circle"></i> Details
          </a>
        </li>
        :
        ''}
        {(!this.state.customerAllJobsPage && !this.state.isQuickLookupJob) ? 
          <li>
            <a
              data-toggle="tab"
              href={"#job-"+this.state.data.id+"-pickup-appraisal"}
            >
              <i className="fa fa-file-signature"></i> Pickup
            </a>
          </li>
        : 
        (this.state.approvePickupAppraisal) ?
          <li>
            <a
              data-toggle="tab"
              href={"#job-"+this.state.data.id+"-pickup-appraisal"}
            >
              <i className="fa fa-file-signature"></i> Pickup
            </a>
          </li> : ""
        }
        {(!this.state.customerAllJobsPage && !this.state.isQuickLookupJob) ? 
          <li>
            <a
              data-toggle="tab"
              href={"#job-"+this.state.data.id+"-dropoff-appraisal"}
            >
              <i className="fa fa-file-signature"></i> Dropoff
            </a>
          </li>
         :  
         (this.state.approveDropoffAppraisal) ?
          <li>
            <a
              data-toggle="tab"
              href={"#job-"+this.state.data.id+"-dropoff-appraisal"}
            >
              <i className="fa fa-file-signature"></i> Dropoff
            </a>
          </li> : ""
        }
        {(!this.state.isQuickLookupJob) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-paperwork"}
          >
            <i className="fa fa-file"></i> Paperwork
          </a>
        </li>
        : ""}
        {!this.state.isQuickLookupJob ? 
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-expenses"}
          >
            <i className="fa fa-file-invoice-dollar"></i> Expenses
          </a>
        </li>
         : ""} 
        {(!this.state.customerAllJobsPage && !this.state.isQuickLookupJob) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-invoice"}
          >
            <i className="fa fa-file-invoice"></i> Invoice
          </a>
        </li>
        : ""}
        {(!this.state.isQuickLookupJob) ? 
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-driver-documents"}
          >
            <i className="fa fa-folder"></i> Documents
          </a>
        </li>
        : ""}
        {(!this.state.customerAllJobsPage && !this.state.isQuickLookupJob)?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-driver-messages"}
          >
            <i className="fa fa-envelope"></i> Messages
          </a>
        </li>
        : ""}
        {(!this.state.customerAllJobsPage && !this.state.isQuickLookupJob) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-notifications"}
          >
            <i className="fa fa-bell"></i> Notifications
          </a>
        </li>
        : ""}
        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-tools"}
            className={(this.state.isQuickLookupJob) ? 'active' : ''}
          >
            <i className="fa fa-tools"></i> Tools
          </a>
        </li>
        : ""}
        {(!this.state.customerAllJobsPage && !this.state.isQuickLookupJob) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-settings"}
          >
            <i className="fa fa-cog"></i> Settings
          </a>
        </li>
        : ""}
        {(!this.state.customerAllJobsPage && !this.state.isQuickLookupJob)?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-call-informations"}
          >
            <i className="fa fa-phone"></i> Call Details
          </a>
        </li>
        : ""}
        {(!this.state.customerAllJobsPage && !this.state.isQuickLookupJob)?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-internal-job-notes"}
          >
            <i className="fa fa-bell"></i> Internal Job Notes
          </a>
        </li>
        : ""}
        
      </ul>
    );
  }
}